import { createRootRoute } from '@tanstack/react-router';
import { AppLayout } from '@/components/AppLayout';
import { TeamsLayout } from '@/components/TeamsLayout';
import { isTeamsApp } from '@/utils/appType';

/**
 * Root route component that conditionally renders the appropriate layout
 * based on whether the app is running in Teams or as a standalone web app
 */
const RootLayout = isTeamsApp() ? TeamsLayout : AppLayout;

export const Route = createRootRoute({
  component: RootLayout,
});